import {getUserInfo} from "Core/containers/Auth/redux/actions";
import {catalogProcessItems} from "Core/catalogs/redux/actions";


export class PREFERENCE {
    execute = (data, state, dispatch) => {
        dispatch(catalogProcessItems("Preference", data))
        dispatch(getUserInfo());
        return [false, {}]
    };
}
